import { Controller } from "@hotwired/stimulus"

// Handles the dynamic addition and removal of nested form fields.
// It assumes a template element is available for cloning new fields.
export default class extends Controller {
  static targets = ["links", "template"]

  add(event) {
    event.preventDefault()

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.linksTarget.insertAdjacentHTML("beforebegin", content)
    this.dispatch("change", { bubbles: true })
  }

  remove(event) {
    event.preventDefault()

    const wrapper = event.target.closest(".nested-fields")
    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove()
    } else {
      wrapper.style.display = "none"
      wrapper.querySelector("input[name*='_destroy']").value = "1"
    }
    this.dispatch("change", { bubbles: true })
  }
}
